import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Types
import { RootProps } from './Root.types';

// Config
import routes from './routes';

// Components
import ErrorBoundary from '@views/error-boundary';

const Root = ({ store, persistor, history }: RootProps) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <ErrorBoundary>{routes(persistor)}</ErrorBoundary>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);

export default Root;
